import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';

interface IMenuHeaderProps {
  isNormal?: boolean;
  onSet?: (value: boolean) => void;
  title?: string;
  selectedTab?: any;
  children?: any;
}

const MenuHeader = (props: IMenuHeaderProps) => {
  const { isNormal, onSet, title, selectedTab, children } = props;

  return <div className="navmenu-hd">
    {isNormal ?
      <>
        <div className="navmenu-hd-title">
          {title}
        </div>
        {children}
      </> :
      <>
        <div className="header-width" onClick={() => { onSet?.(false) }}>
          <SvgIcon className="header-width-title" type="Benchmark" />
        </div>
        <div className="header-width dbb-header-width" onClick={() => { onSet?.(false) }}>
          <SvgIcon className="header-width-title" type={selectedTab?.icon} />
        </div>
      </>
    }
  </div>;
};

export default MenuHeader;